namespace TabAurous.Purchase {
    export interface MaterialInRow {
        TransId?: number;
        TransDate?: string;
        RefTransId?: number;
        RefVoucherId?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AutoPosting?: boolean;
        PartyId?: number;
        LedgerName?: string;
        PartyCode?: string;
        GstVat?: string;
        Address1?: string;
        Country?: string;
        State?: string;
        City?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        RoundOff?: number;
        NetAmount?: number;
        TaxAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        FinancialYearId?: number;
        BillAddId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        UserId?: number;
        ItemDetails?: MaterialInItemsRow[];
        DepartmentId?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        ProductItemImage?: string;
        PostingDate?: string;
        IsPosted?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        Username?: string;
    }

    export namespace MaterialInRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Purchase.MaterialIn';
        export const deletePermission = 'Purchase:Material:Delete';
        export const insertPermission = 'Purchase:Material:Add';
        export const readPermission = '*';
        export const updatePermission = 'Purchase:Material:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            RefTransId = "RefTransId",
            RefVoucherId = "RefVoucherId",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AutoPosting = "AutoPosting",
            PartyId = "PartyId",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            GstVat = "GstVat",
            Address1 = "Address1",
            Country = "Country",
            State = "State",
            City = "City",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            RoundOff = "RoundOff",
            NetAmount = "NetAmount",
            TaxAmount = "TaxAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            FinancialYearId = "FinancialYearId",
            BillAddId = "BillAddId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            UserId = "UserId",
            ItemDetails = "ItemDetails",
            DepartmentId = "DepartmentId",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            ProductItemImage = "ProductItemImage",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            Username = "Username"
        }
    }
}
